<template>
  <img src="/public/img/mas4you/logo-white.svg" alt="Mas4you logo">
</template>
